// extracted by mini-css-extract-plugin
export default {"box":"ButtonMore_box__RwKCz","mobile":"ButtonMore_mobile__aeQPi","btn":"ButtonMore_btn__KlKHo"};